var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0056 2.42643L20.5669 3.9387L22.0792 11.5001C22.1034 11.6211 22.0973 11.7463 22.0616 11.8645C22.0258 11.9827 21.9614 12.0902 21.8741 12.1775L12.0816 21.9699C12.012 22.0396 11.9293 22.0948 11.8383 22.1325C11.7473 22.1702 11.6498 22.1896 11.5513 22.1896C11.4528 22.1896 11.3553 22.1702 11.2643 22.1325C11.1733 22.0948 11.0906 22.0396 11.021 21.9699L2.53569 13.4846C2.46605 13.415 2.4108 13.3323 2.37311 13.2413C2.33542 13.1503 2.31602 13.0528 2.31602 12.9543C2.31602 12.8558 2.33542 12.7583 2.37311 12.6673C2.4108 12.5763 2.46605 12.4936 2.53569 12.424L12.3281 2.63154C12.4154 2.54423 12.523 2.47983 12.6411 2.44405C12.7593 2.40827 12.8845 2.40222 13.0056 2.42643V2.42643Z",
    stroke: "#35383D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 8.8125C16.1072 8.8125 15.6875 8.39277 15.6875 7.875C15.6875 7.35723 16.1072 6.9375 16.625 6.9375C17.1428 6.9375 17.5625 7.35723 17.5625 7.875C17.5625 8.39277 17.1428 8.8125 16.625 8.8125Z",
    fill: "#35383D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.3b79f9a8b40e419fa10bf09783930674.svg";
export { ForwardRef as ReactComponent };